import type { RydeAdminUnit } from "../models/common.models";

export const API_KEY_ENTITY: RydeAdminUnit = "apiKey";

export const ApiKeyConst = {
  /** Lifetime bounds in whole days; the backend enforces the same range. */
  MIN_TTL_DAYS: 1,
  MAX_TTL_DAYS: 365,
  DEFAULT_TTL_DAYS: 365,
  /** apiKeys.name is varchar(100). */
  NAME_MAX_LENGTH: 100,
  /** Shown before the stored token tail, so the grid reads like the end of a longer key. */
  TOKEN_TAIL_PREFIX: "…",
} as const;
